import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76457308"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "element-content" }

import { computed, inject, PropType, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import { PPTVideoElement } from '@/types/slides'
import { injectKeySlideId, injectKeySlideScale } from '@/types/injectKey'

import VideoPlayer from './VideoPlayer/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ScreenVideoElement',
  props: {
  elementInfo: {
    type: Object as PropType<PPTVideoElement>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const { currentSlide } = storeToRefs(useSlidesStore())

const scale = inject(injectKeySlideScale) || ref(1)
const slideId = inject(injectKeySlideId) || ref('')

const inCurrentSlide = computed(() => currentSlide.value.id === slideId.value)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "screen-element-video",
    style: _normalizeStyle({
      top: __props.elementInfo.top + 'px',
      left: __props.elementInfo.left + 'px',
      width: __props.elementInfo.width + 'px',
      height: __props.elementInfo.height + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "rotate-wrapper",
      style: _normalizeStyle({ transform: `rotate(${__props.elementInfo.rotate}deg)` })
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_unref(inCurrentSlide))
          ? (_openBlock(), _createBlock(VideoPlayer, {
              key: 0,
              width: __props.elementInfo.width,
              height: __props.elementInfo.height,
              src: __props.elementInfo.src,
              poster: __props.elementInfo.poster,
              scale: _unref(scale)
            }, null, 8, ["width", "height", "src", "poster", "scale"]))
          : _createCommentVNode("", true)
      ])
    ], 4)
  ], 4))
}
}

})